import { TypedLinkField } from './TypedLinkField';
import type { TopicDetails } from '@/types/topic';

export const AttachmentsField = (p: { details: TopicDetails; langs: string[]; onChange: (d: TopicDetails) => void }) => (
  <TypedLinkField {...p} linkType="attachment" label="Attachments" urlPlaceholder="https://…/file" />
);
